import { Component, ViewChild } from '@angular/core';
import { GenericDataViewService } from '../generic-data-view.service';
import { App, IonicPage, Nav, NavController, NavParams } from 'ionic-angular';
import { ListConfig } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/list-config.interface';
import { FiltersConfig } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filters-config.interface';
import { FiltersService } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/filters/filters.service';
import { ListRendererComponent } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/list/list.component';
import { ProcessFormService } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process-form.service';
import { FormDefinition } from '../../submodules/sellions_forms/projects/forms/src/lib/interfaces/form-definition.interface';
import { ProcessWrapperService } from '../../modules/core/services/process-wrapper-service/process-wrapper.service';
import { SuperTab } from 'ionic2-super-tabs';
import { FilterSet } from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/filter-set.interface';
import { TextServiceProvider } from '../../modules/core/services/text-service/text-service';
import {
  ProcessEntry
} from '../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/interfaces/screen-actions.interface';

@IonicPage()
@Component({
  selector: 'generic-data-view-list',
  templateUrl: './generic-data-view-list.page.html',
  providers: [FiltersService]
})
export class GenericDataViewListPage {
  @ViewChild('list') list: ListRendererComponent;
  public config: ListConfig;
  public filtersConfig: FiltersConfig;
  public baseUrl: string;
  public title: string = '';
  public db: any;
  public dataReceived: boolean = false;
  private viewId: string;
  public loading: boolean = true;
  public showSearchBar: boolean = false;
  public isFirstEntry: boolean = true;
  public searchQuery: string;
  public emptyListMessage: string;
  public filterSetPromise: Promise<FilterSet>;

  constructor(
    private app: App,
    private genericDataViewService: GenericDataViewService,
    protected navParams: NavParams,
    private navController: NavController,
    private filtersService: FiltersService,
    private processService: ProcessWrapperService,
    private processFormService: ProcessFormService,
    private textService: TextServiceProvider,
  ) {
    this.setTitle();
    this.trySetConfig();
    this.filtersService.filterSetSubject$.subscribe((filterSet: FilterSet) => {
      let searchQuery = (filterSet && filterSet.searchQuery) || '';
      this.searchQuery = searchQuery;
    });
  }

  ionViewDidEnter(): void {
    if (!this.isFirstEntry) {
      this.list.reload();
    }
    this.isFirstEntry = false;
  }

  private setTitle(): void {
    const pageTitle = this.getTitle();
    if (!pageTitle) {
      console.warn('[GenericDataViewListPage] A page title is missing');
    } else {
      this.title = pageTitle;
    }
  }

  private getTitle(): string {
    const layout = this.navParams.data;
    if (layout && layout.title) {
      return layout.title;
    }

    const tabTitle = this.navController['title'];
    return tabTitle ? tabTitle : null;
  }

  private trySetConfig(): void {
    try {
      this.setConfig();
    } catch (error) {
      console.error('[LayoutRendererPage] The nav will be redirected to the loading page due to an error that occurred', error);
      this.navController.setRoot('LoadingPage');
    }
  }

  private setConfig(): void {
    this.viewId = this.getViewId();
    this.config = this.genericDataViewService.getConfig(this.viewId);
    this.filtersConfig = this.config.filtersViewId ? this.genericDataViewService.getConfig(this.config.filtersViewId) : null;
    if(this.filtersConfig) {
      this.filterSetPromise = this.filtersService.setConfig(this.config.name, this.filtersConfig);
    }
    this.baseUrl = this.genericDataViewService.getBaseUrl(this.config);
    this.showSearchBar = this.config.displayConfig.showSearchBar;
    this.emptyListMessage = this.config.emptyListMessage || this.textService.get('noDataAvailable');
  }

  private getViewId(): string {
    const layout = this.navParams.data;
    if (layout && layout.viewId) {
      return layout.viewId;
    }

    const tabViewId = this.navController['tabId'];
    return tabViewId ? tabViewId : null;
  }

  goTo($event: { viewId: string; element?: Object; objectKey?: Object; viewComponent: string }) {
    let nav: any = this.app.getRootNav();
    let activeChildNavs: any[] = nav.getActiveChildNavs();
    if (activeChildNavs.length === 1 && activeChildNavs[0] instanceof Nav) {
      nav = activeChildNavs[0];
    }
    nav.push($event.viewComponent, { viewId: $event.viewId, element: $event.element });
  }

  extractOptionsFromData(data: any[]) {
    if (!this.dataReceived && data.length > 0 && this.filterSetPromise) {
      this.filterSetPromise.then(set => {
        this.filtersService.extractOptionsFromData(this.config.name, data);
        this.dataReceived = true;
      });
    }
  }

  onButtonClick($event: { process?: any; element?: Object }): void {
    let eventObjectCopy = $event ? JSON.parse(JSON.stringify($event)) : null;
    let dataElement = this.getDataElement($event ? $event.process : null);
    this.processFormService.appendFieldsFromMappingParentObjectIntoElement(
      eventObjectCopy,
      this.config.formMappingFromParentObject,
      dataElement,
    );
    this.handleProcessAction(eventObjectCopy.process.processKey, eventObjectCopy.element, eventObjectCopy.process.sendButtonText, $event['process']);
  }

  private getDataElement(processEntry: ProcessEntry) {
    let navParamsElement = this.navParams.data.element ? JSON.parse(JSON.stringify(this.navParams.data.element)) : {};
    let dataElementPrototype = processEntry && processEntry['dateElementPrototype'] ? JSON.parse(JSON.stringify(processEntry['dateElementPrototype'])) :
      this.config.dateElementPrototype ? JSON.parse(JSON.stringify(this.config.dateElementPrototype)) : {};

    return { ...navParamsElement, ...dataElementPrototype };
  }

  private handleProcessAction(processKey: string, data: Object, sendButtonText: string, processEntry?: any): void {
    processEntry = processEntry ? processEntry : this.config.screenActions.processList.find((p) => p.processKey === processKey);
    let formMappingConfig = processEntry && processEntry['formMapping'] ? processEntry : this.config;
    let formFieldParametersConfig = processEntry && processEntry['formFieldParametersConfig'] ? processEntry['formFieldParametersConfig'] : this.config['formFieldParametersConfig'];
    this.processService.getProcessWithForm(processKey).subscribe((formDefinition: FormDefinition) => {
      const fields = formDefinition.form;
      const formName = formDefinition.formName;
      // @ts-ignore
      const formJson = this.processFormService.mapFormData(formMappingConfig, fields, data);
      // @ts-ignore
      this.processFormService.setTechnicalParametersOnField(formFieldParametersConfig, formJson, data);
      this.processService.initProcess({ formJson, key: processKey, formName, sendButtonText }).subscribe(() => {
        this.loading = true;
        setTimeout(() => {
          this.list.reload();
          this.loading = false;
        }, 3000);
      });
    });
  }

  searchQueryChange(query) {
    if (query.length > 0 && query.length < 2) {
      return;
    }
    this.filtersService.applySearch(this.config.name, query);
  }

  setLoading(value): void {
    this.loading = value;
  }
}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-list/generic-data-view-list.page.ts